import { render, staticRenderFns } from "./go-top.vue?vue&type=template&id=25841d40&"
import script from "./go-top.vue?vue&type=script&lang=js&"
export * from "./go-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports